import { call, put, select, takeEvery } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';

import {
  reportsVenuesBookings as reportsVenuesBookingsEntity,
  reportsVenuesRevenue as reportsVenuesRevenueEntity,
} from 'store/saga/entities/bound';
import { selectRouteParams, selectUserVenueIds } from 'selectors/general';

import { VENUES_REPORTS_TYPES } from '../Stats.constants';
import {
  SET_VIEW_BY_UNIT,
  SET_VIEW_BY_RANGE_DAY,
  SET_VIEW_BY_RANGE_WEEK,
  SET_VIEW_BY_RANGE_MONTH,
  SET_VIEW_BY_RANGE_YEAR,
  setSelectedVenueIds,
} from './Venues.reducers';
import { selectViewByUnit, selectViewByRange } from './Venues.selectors';

export function* doFetchVenuesData(dependencies) {
  const viewByUnit = yield select(selectViewByUnit);
  const viewByRange = yield select(selectViewByRange);
  const { venuesReportType } = yield select(selectRouteParams);
  // eslint-disable-next-line default-case
  switch (venuesReportType) {
    case VENUES_REPORTS_TYPES.BOOKINGS:
      yield call(fetchEntityIfNeeded, reportsVenuesBookingsEntity, [dependencies, viewByUnit, viewByRange]);
      break;
    case VENUES_REPORTS_TYPES.REVENUE:
      yield call(fetchEntityIfNeeded, reportsVenuesRevenueEntity, [dependencies, viewByUnit, viewByRange]);
      break;
  }
}

export function* handleRouteEnter(dependencies) {
  const venueIds = yield select(selectUserVenueIds);
  yield put(setSelectedVenueIds(venueIds));
  yield call(doFetchVenuesData, dependencies);
}

export function* watchActions(dependencies) {
  yield takeEvery(SET_VIEW_BY_UNIT, doFetchVenuesData, dependencies);
  yield takeEvery(SET_VIEW_BY_RANGE_DAY, doFetchVenuesData, dependencies);
  yield takeEvery(SET_VIEW_BY_RANGE_WEEK, doFetchVenuesData, dependencies);
  yield takeEvery(SET_VIEW_BY_RANGE_MONTH, doFetchVenuesData, dependencies);
  yield takeEvery(SET_VIEW_BY_RANGE_YEAR, doFetchVenuesData, dependencies);
}
